import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  apiBaseUrl: process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || '/api',
  socketUrl: process.env.REACT_APP_SOCKET_URL,
  mqttUrl: process.env.REACT_APP_MQTT_URL || 'ws://localhost:8884',
  appName: process.env.REACT_APP_NAME || 'Indus SHM',
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {},
});

export const selectApiBaseUrl = (state) => state.config.apiBaseUrl;
export const selectSocketUrl = (state) => state.config.socketUrl;
export const selectMqttUrl = (state) => state.config.mqttUrl;
export const selectAppName = (state) => state.config.appName;

export default configSlice.reducer;
